module.exports = __webpack_public_path__ + "theme/assets/img/bf17c3e1d9d85f2516e5c75817c17577.jpg";